import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  className?: string;
  children: React.ReactNode;
  hover?: boolean;
  onClick?: () => void;
}
export function Card({
  className = '',
  children,
  hover = false,
  onClick
}: CardProps) {
  return <motion.div whileHover={hover ? {
    y: -5,
    transition: {
      duration: 0.2
    }
  } : undefined} onClick={onClick} className={`bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-6 ${hover ? 'cursor-pointer hover:bg-white/10 hover:border-white/20' : ''} transition-colors duration-300 ${className}`} data-id="element-646">
      {children}
    </motion.div>;
}